export default {
  inserted(el, binding) {
    lazy_load(el, binding);
  },
  update(el, binding) {
    lazy_load(el, binding);
  }
}


function lazy_load (el, binding) {
	if(!binding.value) {
		return;
  }
  
	let l = binding.value.split(' ').join('%20');
	if(typeof IntersectionObserver === "undefined") {
		return el.style.backgroundImage = 'url('+l+')';
	}
	var io = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
      if(typeof entry.isIntersecting === 'undefined') {
        observer.disconnect();
		    return el.style.backgroundImage = 'url('+l+')';
      }
			if(entry.isIntersecting) {
        

				el.style.backgroundImage = 'url('+l+')';
        observer.disconnect();

        //window.tq.append('i['+el.dataset.position+']', el.id);
        window.tq['i['+el.dataset.position+']'] = el.id;
        
        
			}
		});
	});
	io.observe(el)
}
